export const reviews = [
  {
    id: 1,
    name: "Marie-Claire D.",
    initial: "M",
    color: "bg-amber-100 text-amber-700",
    stars: 5,
    date: "Il y a 2 semaines",
    text: "Intervention ultra rapide ! Porte claquée à 23h, le serrurier était là en 18 minutes. Professionnel, efficace et prix honnête. Je recommande vivement Securycles à tous mes voisins de Créteil.",
  },
  {
    id: 2,
    name: "Thomas B.",
    initial: "T",
    color: "bg-green-100 text-green-700",
    stars: 5,
    date: "Il y a 1 mois",
    text: "Installation d'une serrure connectée Nuki dans mon appartement à Vitry-sur-Seine. Travail soigné, explications claires sur l'utilisation. Très satisfait du résultat, je recommande !",
  },
  {
    id: 3,
    name: "Fatima K.",
    initial: "F",
    color: "bg-rose-100 text-rose-700",
    stars: 5,
    date: "Il y a 3 semaines",
    text: "Clés enfermées dans ma voiture devant le centre commercial de Créteil. Securycles est arrivé en 20 min, ouverture sans dégât. Merci infiniment, vous m'avez sauvé la mise !",
  },
  {
    id: 4,
    name: "Jean-Pierre M.",
    initial: "J",
    color: "bg-blue-100 text-blue-700",
    stars: 5,
    date: "Il y a 2 mois",
    text: "Remplacement de serrure suite à un cambriolage à Saint-Maur. Intervention le soir même, pose d'une serrure 3 points de qualité. Sérieux et rassurant dans une situation stressante.",
  },
  {
    id: 5,
    name: "Amina S.",
    initial: "A",
    color: "bg-purple-100 text-purple-700",
    stars: 5,
    date: "Il y a 1 semaine",
    text: "Excellent serrurier à Champigny ! Devis transparent par téléphone, pas de mauvaise surprise à l'arrivée. Travail propre et rapide. Je garde le numéro précieusement.",
  },
  {
    id: 6,
    name: "Karim L.",
    initial: "K",
    color: "bg-orange-100 text-orange-700",
    stars: 5,
    date: "Il y a 3 mois",
    text: "Securycles a changé toutes mes serrures après un déménagement à Maisons-Alfort. Rapport qualité/prix imbattable, ponctuel et très professionnel. 5 étoiles méritées !",
  },
];
